import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { departmentsOptionsConstant, documentTemplateOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonSummaryService } from 'src/app/services/common/common-summary.service';
import { AdministrationSummaryService } from '../../../services/administration/administration-summary.service';
import { httpOptions, serviceConstants } from '../../../constants/service.constants';
import { DateObject, Document_Upload_File } from '../../../models/common';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { FilePreviewComponent } from '../../document-summary/file-preview/file-preview.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-attachments-view-modal',
  templateUrl: './attachments-view-modal.component.html',
  styleUrls: ['./attachments-view-modal.component.scss']
})
export class AttachmentsViewModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  departments = departmentsOptionsConstant;
  DocumentTypeList:any = [];
  AttachmentModal: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  document_attach_list: Document_Upload_File[] = [];
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  SavedAttachments = [];
  ApplicationID: any;
  permission: string = "";
  Cancel:string="Cancel";
  ModuleName:string;
  module:string;
  MODULE_ID: string;
Full_date :DateObject;
  constructor(
    private activatedRoute: ActivatedRoute,
    private criteriaService: CommonCriteriaService,
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    private commonService: CommonService,
    public datepipe: DatePipe

  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.ApplicationID =this.commonService.appId;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.module = params['module'];

        if (this.module == "ist"){
          this.MODULE_ID = "2";
        }
        if (this.module == "grants"){
          this.MODULE_ID = "4";
        }
      }      
    });

    this.files = [];
    this.permission = "";
    var lper = this.commonService.getPagePermission("IST16");
    if (lper != null && lper) {
      //;
      this.permission = lper.toLowerCase();
    }

    this.AttachmentModal = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      DocumentType: new UntypedFormControl("", [Validators.required]),
      DateFrom: new UntypedFormControl(null),
      Comments: new UntypedFormControl(""),
      DateFromO: new UntypedFormControl(null)
    });
    
    if (this.Content.heading == "Add" || this.Content.heading == "Edit") {
      let todayData = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
      this.AttachmentModal.controls["DateFrom"].setValue(todayData);
      this.AttachmentModal.controls["DateFrom"].disable();
    }
    this.getMasterData();

    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.GetAttachmentData();
    }
    if (this.Content.heading == "View"){
      this.Cancel = "Close";
    }
  }
  getMasterData() {
   /*  this.summaryService.GetMasterScreenData("api/ISTFileAttachments/GetMasterData").subscribe(summary => {
      this.DocumentTypeList = summary;
       });
 */
       this.ModuleName="IST";
       this.summaryService.GetMasterScreenData("api/ISTFileAttachments/GetAttachClass?ModuleName=" + this.ModuleName).subscribe(result => {
        this.DocumentTypeList = result["MasterData1"];
        this.DocumentTypeList=  [{label:"Select",value:"", checked: true}].concat(this.DocumentTypeList);
      });
  
  }
  GetAttachmentData() {
    this.summaryService.GetMasterScreenData("api/ISTFileAttachments/GetDocumentData?RecordID=" + this.Content.content.id).subscribe(summary => {
      if (summary["DateFrom"] != null && summary["DateFrom"] != "" && summary["DateFrom"] != undefined) {
        var formd2 = this.datepipe.transform(summary["DateFrom"], 'dd-MMM-yyyy');
        summary["DateFrom"] = formd2;
      }
    
      this.AttachmentModal.patchValue(summary);

      if (this.permission == "view" || this.Content.heading == "View") {
        this.AttachmentModal.disable();
      }
      this.SavedAttachments = summary["Attachments"];
    });
  }

  todaydate()
  {  let todayData = new Date();
    this.Full_date = 
    {
          Day: todayData.getDate(),
          Month: todayData.getMonth() + 1,
          Year: todayData.getFullYear(),
          Hours: 0,
          Minutes: 0,
          Seconds: 0,
          IsEndDate: false,
          HasValue: true
        }
      
  }
  save() {
    if (this.validateControls()) {
      debugger;
      var formData = this.AttachmentModal.value;

      formData["MODULE_ID"] = this.MODULE_ID;
      if (formData["DateFrom"] != null && formData["DateFrom"] != undefined) {
        formData["DateFrom"] = new Date(formData["DateFrom"]);
        formData["DateFromO"] = this.Full_date;
      }
      formData["ApplicationID"] = this.ApplicationID;

      var SUobj = this.DocumentTypeList.filter(function (element) 
          {
            return element.value == formData.DocumentType;
          })[0];
          if (SUobj != null && SUobj != undefined) {
            formData["Classification"] = SUobj.label;
            }
          else {
              formData["Classification"] = "";
            }

      let formData1 = new FormData();
      if (this.document_attach_list != null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      formData["Attachments"]= this.SavedAttachments;
      formData1.append("ScreenData", JSON.stringify(formData));

      if (this.Content.heading === 'Add') {
        this.summaryService.InsertWithFiles("api/ISTFileAttachments/InsertAttachment", formData1).subscribe(summary => {
          if(summary.Status === 0){
          this.commonService.SuccessBanner('Attachment(s) added successfully')
        //  this.action.next();
          this.modalRef.close();
        }
      else{
        this.commonService.ValidationBanner(summary.Message);
        //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: summary.Message } } });
        }
        });
      }
      else {
        this.summaryService.InsertWithFiles("api/ISTFileAttachments/UpdateAttachemnt", formData1).subscribe(summary => {
          if(summary.Status === 0){
            this.commonService.SuccessBanner('Attachment(s) updated successfully')
           // this.action.next();
            this.modalRef.close();
          }
        else{
          this.commonService.ValidationBanner(summary.Message);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: summary.Message } } });
          }
          });
      }
    }
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.AttachmentModal.value;
    if (formData.DocumentType === null || formData.DocumentType === "") {
      $("#DocumentType").addClass("ng-touched ng-invalid validate-error");
      $("#DocumentType").removeClass("ng-untouched ng-valid");
      message += "Please select Attachment Classification<br/>";
      isValid = false;
    } else {
      $("#DocumentType").addClass("ng-untouched ng-valid");
      $("#DocumentType").removeClass("ng-touched ng-invalid validate-error");
    }

    
    if (this.Content.heading == "Edit" && this.SavedAttachments.length > 0) {

    }
    else {
      if (this.document_attach_list != null && this.document_attach_list.length == 0) {
        message += "Please upload Attachments<br/>";
        isValid = false;
      }
    }
    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }
 
  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");  
    }
    
  
    uploadchange(event): void {
      let hasUnFormat = false;
      if (this.document_attach_list == undefined || this.document_attach_list == null) {
        this.document_attach_list = [];
      }
      for (let i = 0; i < event.target.files.length; i++) {
        let uploadFile = new Document_Upload_File();
        var file = event.target.files[i].name;   
        var ext = file.match(/\.([^\.]+)$/)[1];
        var filesize = event.target.files[i].size;
  
        if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
        {
          hasUnFormat = true; 
        }
        else 
        {
          let hasValue;
          uploadFile.ID = this.commonService.getUniqueId();
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = event.target.files[i];
          uploadFile.Status = "Add";
          if(this.SavedAttachments && this.SavedAttachments.length > 0 ){
            hasValue = this.SavedAttachments.filter(x=> x.FileName.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
          } else{
            hasValue = this.document_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
          }
          if(hasValue.length > 0)
          {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          } else
          {
            this.document_attach_list.push(uploadFile);
          }
        }
      }
      if(hasUnFormat){
        this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB"); 
      }
    }

  
  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }
  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  DeleteSavedUpload(item): void {
    let code = item;
    this.SavedAttachments = this.SavedAttachments.filter(function (sec) {
      return sec.ID != code;
    }, code);
    /* this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.SavedAttachments = this.SavedAttachments.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }); */
  }
  startUpload(url: any, fromData: any): void {
    
    var url1 = serviceConstants.apiURL + url;
    const event: any = {
      type: 'uploadAll',
      url: url1,
      method: 'POST',
      data: fromData,
    };
    this.files = [];
    this.uploadInput.emit(event);
  }
  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }
}
